import { ApiResponse, ILocation, ILocationTag } from 'src/interfaces';

export const mapAllLocationTags = (
  locationTags: ApiResponse[],
  locations: ILocation[],
): ILocationTag[] => {
  return locationTags.map((locationTag: ApiResponse) => {
    return mapLocationTag(locationTag, locations);
  });
};

export const mapLocationTag = (
  locationTag: ApiResponse,
  locations: ILocation[],
): ILocationTag => {
  const findLocations = locations
    .filter((loc) => loc.location_tag_id.includes(locationTag.id))
    .map((location) => location.location_code);

  return {
    id: locationTag.id,
    name: locationTag.name,
    locations: findLocations,
    created_at: locationTag.created_at,
    modified_at: locationTag.modified_at,
  };
};

export const mapAllLocationOwnerTags = (
  locationTags: ApiResponse[],
  locations: ILocation[],
): ILocationTag[] => {
  return locationTags.map((locationTag: ApiResponse) => {
    return mapLocationOwnerTag(locationTag, locations);
  });
};

export const mapLocationOwnerTag = (
  locationTag: ApiResponse,
  locations: ILocation[],
): ILocationTag => {
  const findLocations = locations
    .filter((loc) => loc.location_owner_tag_id.includes(locationTag.id))
    .map((location) => location.location_code);

  return {
    id: locationTag.id,
    name: locationTag.name,
    locations: findLocations,
    created_at: locationTag.created_at,
    modified_at: locationTag.modified_at,
  };
};

export const validateTagName = (tagName: string): string => {
  const reg = new RegExp('^[a-zA-Z0-9- ]*$');

  return tagName.length <= 45
    ? reg.test(tagName)
      ? ''
      : 'Invalid tag name'
    : 'Tag name must be less than 45 characters';
};
